import { getData, putData } from "../apiClient";

// Get theme settings from API
export const getThemeSettings = async () => {
    try {
        const result = await getData('/theme-settings');
        return {
            data: {
                success: true,
                ...result
            }
        };
    } catch (error) {
        console.error('Get theme settings API error:', error);
        return {
            data: {
                success: false,
                error: error.message
            }
        };
    }
};

// Update theme settings to API
export const updateThemeSettings = async (themeSettings) => {
    try {
        const result = await putData('/theme-settings/update-theme-settings', themeSettings);
        return {
            data: {
                success: true,
                ...result
            }
        };
    } catch (error) {
        console.error('Update theme settings API error:', error);
        return {
            data: {
                success: false,
                error: error.message
            }
        };
    }
};